import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isTokenValid, getSsoPortalUrl } from "../services/ssoAuth";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  // SSO Token immediate extraction fallback
  const hash = window.location.hash || "";
  const search = window.location.search || "";
  if (hash.includes("access_token=") || search.includes("access_token=")) {
    const match = hash.match(/access_token=([^&]+)/) || search.match(/[?&]access_token=([^&]+)/);
    if (match && match[1]) {
      const token = decodeURIComponent(match[1]);
      localStorage.setItem("accessToken", token);
      localStorage.setItem("isAuthenticated", "true");
    }
  }

  // Synchronize logout across browser tabs on the same origin
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "isAuthenticated" && !e.newValue) {
        navigate("/login", { replace: true });
      }
      if (e.key === "accessToken" && !e.newValue) {
        navigate("/login", { replace: true });
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [navigate]);

  const token = localStorage.getItem("accessToken");
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  if (!isAuthenticated || !isTokenValid(token)) {
    localStorage.clear();
    sessionStorage.clear();
    const portalUrl = getSsoPortalUrl();
    window.location.href = `${portalUrl}/login`;
    return null;
  }

  return children;
};

export default ProtectedRoute;